import React from 'react';
import LegalDocumentEditor from '../legal-document/LegalDocumentEditor';
import privacyPolicyApi from '../../services/privacyPolicyApi';

const DEFAULT_DOCUMENT = {
  title: 'KaamDhanda User Privacy Policy',
  company: 'Nirvighna Services Private Limited',
  sections: [],
};

const DEFAULT_PARTNER_DOCUMENT = {
  title: 'KaamDhanda Partner Privacy Policy',
  company: 'Nirvighna Services Private Limited',
  sections: [],
};

const PrivacyPolicyEditor = () => (
  <LegalDocumentEditor
    permissionName="Privacy Policy"
    pageTitle="Privacy Policy Editor"
    pageDescription="Edit user and partner privacy policy JSON documents served by the public API."
    saveSuccessMessage="Privacy Policy saved successfully!"
    defaultDocument={DEFAULT_DOCUMENT}
    defaultPartnerDocument={DEFAULT_PARTNER_DOCUMENT}
    supportsPartnerDocument
    loadDocument={privacyPolicyApi.getPrivacyPolicy}
    saveDocument={privacyPolicyApi.savePrivacyPolicy}
  />
);

export default PrivacyPolicyEditor;
